import { makeStyles } from "@material-ui/core";

export const useStyleMedicineAndCashier = (zoom = 1) => {
    return makeStyles(theme => ({
        container: {
            [theme?.breakpoints.up("1923")]: {
                "& .text-sm": {
                    fontSize: `calc(100% + (10px * ${zoom}))`,
                },
                "& .text-md": {
                    fontSize: `calc(100% + (14px * ${zoom}))`,
                },
                "& .text-lg": {
                    fontSize: `calc(100% + (22px * ${zoom}))`,
                },
                "& .text-xl": {
                    fontSize: `calc(100% + (26px * ${zoom}))`,
                },
                "& .text-xxl": {
                    fontSize: `calc(100% + (72px * ${zoom}))`,
                },
                "& .text-call": {
                    fontSize: `calc(100% + (42px * ${zoom}))`,
                },
                "& .text-call-number": {
                    fontSize: `calc(100% + (74px * ${zoom}))`,
                },
                "& .tab-btn": {
                    height: "auto",
                    "& > p": {
                        fontSize: `calc(100% + (24px * ${zoom}))`,
                    },
                },
                "& .img-logo": {
                    height: 340,
                    margin: "0 5rem",
                },
                "& .box-field-call": {
                    paddingLeft: 60,
                },
                "& .tab-content": {
                    height: "100%",
                },
                "& .grid-container": {
                    display: "flex",
                    flexWrap: "wrap",
                    marginLeft: -10,
                    marginRight: -10,
                    "& .grid-cols": {
                        width: "20%",
                        display: "flex",
                        alignSelf: "stretch",
                        padding: 10,
                    },
                    "&.cols-40 .grid-cols": {
                        width: 100 / 8 + "0%",
                        display: "flex",
                        alignSelf: "stretch",
                        padding: 6,
                    },
                },
            },
            [theme?.breakpoints.down("1922")]: {
                "& .text-sm": {
                    fontSize: `calc(10px * ${zoom})`,
                },
                "& .text-md": {
                    fontSize: `calc(16px * ${zoom})`,
                },
                "& .text-lg": {
                    fontSize: `calc(18px * ${zoom})`,
                },
                "& .text-xl": {
                    fontSize: `calc(20px * ${zoom})`,
                },
                "& .text-xxl": {
                    fontSize: `calc(44px * ${zoom})`,
                },
                "& .text-call": {
                    fontSize: `calc(26px * ${zoom})`,
                },
                "& .text-call-number": {
                    fontSize: `calc(46px * ${zoom})`,
                },
                "& .tab-btn": {
                    height: "auto",
                    "& > p": {
                        fontSize: `calc(16px * ${zoom})`,
                    },
                },
                "& p": {
                    marginBottom: 0,
                },
                "& .img-logo": {
                    height: 120,
                    margin: "0 5rem",
                },
                "& .box-field-call": {
                    paddingLeft: 30,
                },
                "& .tab-content": {
                    height: "100%",
                },
                "& .grid-container": {
                    display: "flex",
                    flexWrap: "wrap",
                    marginLeft: -6,
                    marginRight: -6,
                    "& .grid-cols": {
                        width: "20%",
                        display: "flex",
                        alignSelf: "stretch",
                        padding: 6,
                    },
                    "&.cols-40 .grid-cols": {
                        width: 100 / 8 + "0%",
                        display: "flex",
                        alignSelf: "stretch",
                        padding: 6,
                    },
                },
            },
            "& .slick-dots": {
                position: "static",
            },
        },
    }));
};
